import script from "./NewForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NewForm.vue?vue&type=script&setup=true&lang=js"

import "./NewForm.vue?vue&type=style&index=0&id=7feb579c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7feb579c"]])

export default __exports__